










import { defineComponent, PropType } from 'vue';
import { Location } from 'vue-router';

export default defineComponent({
  name: 'Pill',
  props: {
    selected: { type: Boolean, default: false },
    count: { type: Number, default: 0 },
    to: { type: [Object, String] as PropType<string | Location>, default: '' },
  },
});
